import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";

const SESSION_VIEWING_VISIT_ID = "viewingVisitID";
const SESSION_SUMMARY_VIEWS = "summaryViews";
const SESSION_EMR_TOKEN_JWT = "emrTokenJWT";
const SESSION_EMR_FIRST_NAME = "firstName";
const SESSION_EMR_LAST_NAME = "lastName";
const SESSION_EMAIL = "email";
const SESSION_VISIT_INDEX_FILTER = "visitIndexFilter";

// expire in 1 day
const SESSION_EXPIRES_DAYS = 1;

export function setViewingVisitID(visitID) {
  // sessionStorage.setItem(SESSION_VIEWING_VISIT_ID, visitID);
  return setCookieWithExpiration(SESSION_VIEWING_VISIT_ID, visitID);
}
export function getViewingVisitID() {
  // return sessionStorage.getItem(SESSION_VIEWING_VISIT_ID);
  return Cookies.get(SESSION_VIEWING_VISIT_ID);
}
export function setSummaryViews(summaryViews) {
  // sessionStorage.setItem(SESSION_SUMMARY_VIEWS, summaryViews);
  return setCookieWithExpiration(SESSION_SUMMARY_VIEWS, summaryViews);
}
export function getSummaryViews() {
  // return sessionStorage.getItem(SESSION_SUMMARY_VIEWS);
  return Cookies.Get(SESSION_SUMMARY_VIEWS);
}
export function getFirstName() {
  // return sessionStorage.getItem(SESSION_EMR_FIRST_NAME);
  return Cookies.get(SESSION_EMR_FIRST_NAME);
}
export function setFirstName(firstName) {
  // sessionStorage.setItem(SESSION_EMR_FIRST_NAME, firstName);
  return setCookieWithExpiration(SESSION_EMR_FIRST_NAME, firstName);
}

export function getLastName() {
  // return sessionStorage.getItem(SESSION_EMR_LAST_NAME);
  return Cookies.get(SESSION_EMR_LAST_NAME);
}
export function setLastName(lastName) {
  // sessionStorage.setItem(SESSION_EMR_LAST_NAME, lastName);
  return setCookieWithExpiration(SESSION_EMR_LAST_NAME, lastName);
}

export function getEmail() {
  // return sessionStorage.getItem(SESSION_EMAIL);
  return Cookies.get(SESSION_EMAIL);
}
export function setEmail(email) {
  // sessionStorage.setItem(SESSION_EMAIL, email);
  return setCookieWithExpiration(SESSION_EMAIL, email);
}
export function isAssistant() {
  const decoded = jwt_decode(getEMRTokenJWT());
  return decoded.isAssistant || false;
}
export function isAdmin() {
  const decoded = jwt_decode(getEMRTokenJWT());
  return decoded.isAdmin || false;
}
export function isSuperAdmin() {
  const decoded = jwt_decode(getEMRTokenJWT());
  return decoded.isSuperAdmin || false;
}
export function isMedicalDirector() {
  const decoded = jwt_decode(getEMRTokenJWT());
  return decoded.isMedicalDirector || false;
}
export function isScriptsureUser() {
  const decoded = jwt_decode(getEMRTokenJWT());
  return decoded.scriptsureEmail != ""; // has a scriptsure email, therefore is a scriptsure user
}
export function getEMRTokenJWT() {
  return Cookies.get(SESSION_EMR_TOKEN_JWT);
}
export function setEMRTokenJWT(token) {
  return setCookieWithExpiration(SESSION_EMR_TOKEN_JWT, token);
}
export function getVisitIndexFilter() {
  return Cookies.get(SESSION_VISIT_INDEX_FILTER);
}
export function setVisitIndexFilter(filter) {
  return setCookieWithExpiration(SESSION_VISIT_INDEX_FILTER, filter);
}
export function getDoctorID() {
  const decoded = jwt_decode(getEMRTokenJWT());
  return decoded.doctorID;
}

export function isMedicalProvider() {
  const decoded = jwt_decode(getEMRTokenJWT());
  const emptyUUID = "00000000-0000-0000-0000-000000000000";
  return decoded.doctorID && decoded.doctorID !== "" && decoded.doctorID !== emptyUUID;
}

export function clearCookies() {
  Cookies.remove(SESSION_VIEWING_VISIT_ID);
  Cookies.remove(SESSION_SUMMARY_VIEWS);
  Cookies.remove(SESSION_EMR_TOKEN_JWT);
  Cookies.remove(SESSION_EMR_FIRST_NAME);
  Cookies.remove(SESSION_EMR_LAST_NAME);
  Cookies.remove(SESSION_EMAIL);
  Cookies.remove(SESSION_VISIT_INDEX_FILTER);

  setEMRTokenJWT("");
}

export function isLoggedIn() {
  // Weird caching bug? where using Cookies.get(SESSION_EMR_TOKEN_JWT ) incorrectly returns a cleared value
  // console.log("Cookies:", Cookies.get());
  const token = Cookies.get()[SESSION_EMR_TOKEN_JWT];
  if (token != null) {
    try {
      const decoded = jwt_decode(token);
      const expDate = new Date(decoded.exp * 1000); // js uses nanoseconds, so need to x1000 to compare
      // console.log("expDate:", expDate);
      // console.log(expDate > new Date().getTime());
      return expDate > new Date().getTime(); // logged in if expiration date is > now.
    } catch (error) {
      return false;
    }
  }

  // return token != null && token != "";
  return false;
}

function setCookieWithExpiration(key, value, expires = null) {
  if (expires == null) {
    // No "expires" sets session-only cookie
    return Cookies.set(key, value);
  } else {
    // persistent cookie with expiration
    return Cookies.set(key, value, { expires: expires });
  }
}
